module.exports = __webpack_public_path__ + "img/pigai-order.4cd64922.png";